import { render, staticRenderFns } from "./commissionDetails.vue?vue&type=template&id=519e19f2&scoped=true&"
import script from "./commissionDetails.vue?vue&type=script&lang=js&"
export * from "./commissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./commissionDetails.vue?vue&type=style&index=0&id=519e19f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e19f2",
  null
  
)

export default component.exports